import { ICnasClient, CnasClient } from '@atlassiansox/asc-cnas';
import React, { createContext, PropsWithChildren, useContext } from 'react';

const CnasClientContext = createContext<ICnasClient>(new CnasClient());

export function useCnasClient(): ICnasClient {
  return useContext(CnasClientContext);
}

export type CnasClientProviderProps = PropsWithChildren<{
  readonly client: ICnasClient;
}>;

export function CnasClientProvider({
  client,
  children
}: CnasClientProviderProps) {
  return (
    <CnasClientContext.Provider value={client}>
      {children}
    </CnasClientContext.Provider>
  );
}
